import { ToolMode } from 'cornerstone-tools';

export const VISIBLE_TOOLS = ['active', 'passive', 'enabled'] as ToolMode[];
export const isVisibleToolState = (value: string): value is typeof VISIBLE_TOOLS[number] => {
  return (VISIBLE_TOOLS as unknown as string[]).includes(value);
};
export const DISPLAYED_NON_DATA_TOOLS = ['DicomDataPrinter'] as string[];
